import { useMsal } from '@azure/msal-react';
import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import './Login.scss';
import LayoutLogo from '../../components/layout/main/LayoutLogo';
import microsoftLogo from '../../assets/img/microsoft-logo.png';
import {
  directTypes,
  redirectToAzureAD
} from '../../utilities';
import LoginForm from './LoginForm';
import { showModal } from '../../actions/auth';
import { bindActionCreators } from 'redux';
import {
  Box,
  Button as ButtonMantine,
  Divider,
  Flex,
  Group,
  Image,
  Menu,
  Text
} from '@mantine/core';
import { IMG_MYSTERYMAN } from '../../components/c_avatar/Avatar.const';
import Button from '../../components/elements/Button';
import { FiChevronDown, FiHome, FiLogOut } from 'react-icons/fi';
import ModalWrapper from '../../components/elements/ModalWrapper';
import { useMediaQuery } from '@mantine/hooks';

const Login = (props) => {
  const smScreen = useMediaQuery('(max-width: 62em)');
  const [loading, setLoading] = useState(false);

  const { instance } = useMsal();

  const doLogin = () => {
    setLoading(true);
    props.showModal(false);
    redirectToAzureAD(directTypes.LOGIN, instance, (res, success) => {
      setLoading(false);
    });
  };

  const handleShow = () => {
    props.showModal(!props.isShow);
  };

  const photo = props.photo();

  useEffect(() => {
    const anyReturnUrl = !!window.localStorage.getItem('return_url');
    props.showModal(props.isShow || anyReturnUrl);
  }, []);

  return (
    <>
      {!props.auth && (
        <Button
          loading={props.isFetching}
          disabled={props.isFetching}
          onClick={handleShow}
        >
          Login
        </Button>
      )}

      {props.auth && !props.isFetching && (
        <Menu>
          <Menu.Target>
            <ButtonMantine
              loading={props.isFetching}
              disabled={props.isFetching}
              px={smScreen ? 12 : 4}
              py={4}
              variant="transparent"
              c="dark"
              radius={'md'}
              h={'fit-content'}
              styles={{
                inner: {
                  display: smScreen ? 'initial' : 'flex'
                },
                label: {
                  width: smScreen ? 'initial' : 'flex'
                }
              }}
            >
              <Group
                gap={4}
                justify="space-between"
                w={smScreen ? '100%' : 'fit-content'}
              >
                <Group gap={smScreen ? 12 : 4}>
                  <Box w={25} h={25}>
                    <Image
                      src={photo || IMG_MYSTERYMAN}
                      w={smScreen ? 24 : 25}
                      h={smScreen ? 24 : 25}
                      radius={35}
                    />
                  </Box>
                  <Text fz={smScreen ? 12 : 14} fw={700}>
                    {props.auth.fullName.length > 10
                      ? props.auth.fullName.substring(0, 10) + '...'
                      : props.auth.fullName}
                  </Text>
                </Group>
                <FiChevronDown size={24} />
              </Group>
            </ButtonMantine>
          </Menu.Target>

          <Menu.Dropdown w={smScreen && '100%'}>
            <Menu.Item
              component="a"
              href="/home"
              fw={700}
              fz={smScreen ? 12 : 14}
              style={{
                textDecoration: 'none'
              }}
              leftSection={<FiHome />}
            >
              Homepage
            </Menu.Item>
            <Menu.Item
              component="a"
              c="red"
              fw={700}
              fz={smScreen ? 12 : 14}
              href="/logout"
              style={{
                textDecoration: 'none'
              }}
              leftSection={<FiLogOut />}
            >
              Logout
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      )}

      <ModalWrapper
        isVisible={props.isShow}
        onClose={() => {
          props.showModal(!props.isShow)
          window.localStorage.removeItem('return_url');
        }}
      >
        <LayoutLogo />

        <Flex direction={'column'} mt={32}>
          <Text c={'dark'} fz={14} fw={600} mb={8}>
            Login with Employee/Teacher/Lecturer account
          </Text>

          <Button onClick={doLogin} loading={loading} variant="outline">
            <img src={microsoftLogo} className="mr-2" /> Sign in with Microsoft
          </Button>
        </Flex>

        <Divider
          my={32}
          labelPosition="center"
          label={<Text fz={12}>Or</Text>}
        />

        <LoginForm />
      </ModalWrapper>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.userData,
    isFetching: state.auth.isFetching,
    isShow: state.auth.isShow
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ showModal }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
